import React, { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Grid, Typography } from '@material-ui/core';
import { RMSTextField } from '../../shared/components/form-controls';
import { RMSButton } from '../../shared/components/buttons';
import CreateFormResolver from '../../shared/utility/createFormResolver';
import KEYBOARD_KEYS from '../../shared/constants/keyboardKeys';
import portalLoginSchema from '../schema/portalLoginSchema';
import { submitLoginForm } from 'reducers/UserReducer';
import ptsLogo from '../../../assets/images/PTS-logo.png';
import { EVIDENCE_ROUTE_PATHS } from '../constants/evidenceRoutePaths';

const EvidencePortalLogin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const secondFactor = useSelector((state) => state.user.secondFactor);
  const passwordFieldShouldReset = useSelector((state) => state.user.passwordFieldShouldReset);

  const methods = useForm({
    resolver: CreateFormResolver(portalLoginSchema),
    mode: 'onSubmit',
    defaultValues: { username: '', password: '', otp: '' },
  });

  const { handleSubmit } = methods;

  useEffect(() => {
    if (isAuthenticated) {
      history.replace(EVIDENCE_ROUTE_PATHS.portal);
    }
  }, [isAuthenticated, history]);

  const handleLogin = handleSubmit((values) => {
    if (secondFactor) {
      dispatch(submitLoginForm(values.username, values.password, false, values.otp));
    } else {
      dispatch(submitLoginForm(values.username, values.password));
    }
  });

  const handleKeyDown = (event) => {
    if (event.key === KEYBOARD_KEYS.ENTER) {
      event.preventDefault();
      handleLogin();
    }
  };

  return (
    <div className="evidence-portal-login">
      <div className="evidence-portal-login__card">
        <img src={ptsLogo} alt="PTS Solutions" className="evidence-portal-login__logo" />
        <Typography variant="h6" className="evidence-portal-login__title">
          Officer Evidence Portal
        </Typography>

        <FormProvider {...methods}>
          <Grid container spacing={3}>
            {secondFactor ? (
              <>
                <Grid item xs={12}>
                  <Typography variant="body2" className="evidence-portal-login__hint">
                    A verification code has been emailed to you. Enter it below to continue.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <RMSTextField
                    name="otp"
                    label="Verification Code"
                    autoFocus
                    onKeyDown={handleKeyDown}
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12}>
                  <RMSTextField name="username" label="Username" autoFocus />
                </Grid>
                <Grid item xs={12}>
                  <RMSTextField
                    name="password"
                    label="Password"
                    type="password"
                    onKeyDown={handleKeyDown}
                  />
                </Grid>
              </>
            )}

            {passwordFieldShouldReset && (
              <Grid item xs={12}>
                <Typography variant="body2" className="evidence-portal-login__hint">
                  Your password needs to be reset. Please sign in through the main application to
                  reset it.
                </Typography>
              </Grid>
            )}

            <Grid item xs={12}>
              <RMSButton
                label="Sign In"
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleLogin}
              />
            </Grid>
          </Grid>
        </FormProvider>
      </div>
    </div>
  );
};

export default EvidencePortalLogin;
